<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'AdminUsers'}">
              <h4 class="ms-2">
                {{label.pages.personnels}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                 ({{label.pages.manageAdminUsers}})
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="items"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxColumnChooser
                :enabled="true"
                mode="dragAndDrop"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                        variant="ps-success"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.addUser"
                        @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{data}">
              <div>
                <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                      @click="delConfirm(data)"
                      :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <template #ban="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="ban(data)"
                      :id="'blockBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="slash-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'blockBtnTlp-' + data.data.id"
                  >
                    {{ label.pages.blockedUser }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxSorting mode="multiple"/>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
            <DxStateStoring
                :enabled="true"
                type="localStorage"
                storage-key="adminUsersList"
            />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
        dir="rtl"
        v-model="addModal"
        header-bg-variant="ps-success"
        centered
        size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.newUser}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addModal=false"
            id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="6">
            <b-row class="mb-3 mt-1">
              <b-col sm="3">
                <label for="firstName" class="ps_label">
                  {{label.form.firstName}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="firstName" size="sm" v-model="form.firstName"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="mb-3 mt-1">
              <b-col sm="3">
                <label for="lastName" class="ps_label">
                  {{label.form.lastName}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="lastName" size="sm" v-model="form.lastName"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="mobile" class="ps_label">
                  {{label.form.phoneNumber}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="mobile" size="sm" v-model="form.mobile" type="number"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="userRole" class="ps_label">
                  {{label.form.userRole}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <treeselect
                    id="userRole"
                    :options="roles"
                    :placeholder="label.pages.searchTitle"
                    v-model="form.role"
                    :normalizer="normalizer"
                    multiple
                ></treeselect>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="usernameUser" class="ps_label">
                  {{label.form.username}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="usernameUser" name="userUsername" size="sm" autocomplete="off" dir="ltr" v-model="form.username" type="text"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="nationalCode" class="ps_label">
                  {{label.form.nationalCode}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="nationalCode" size="sm" v-model="form.nationalCode" type="number"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="passwordUser" class="ps_label">
                  {{label.form.password}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="passwordUser" name="userPass" size="sm" autocomplete="off" v-model="form.password" type="password"/>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col sm="auto">
                <label for="rePassword" class="ps_label">
                  {{label.form.repeatPassword}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col >
                <b-form-input id="rePassword" size="sm" v-model="form.confirmPassword" type="password"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row v-if="dropZoneAction" class="mt-3">
              <b-col cols="3" class="text-center pt-4">
                <label for="image" class="ps_label">
                  {{label.form.avatar}}
                </label>
              </b-col>
              <b-col>
                <b-row class="justify-content-center align-self-center">
                  <b-col cols="12" class="profile-avatar align-self-center">
                    <img
                        v-if="form.image"
                        id="avatarb"
                        :src="form.image"
                        style="width: 100px; height: 100px;"
                        alt="user avatar"
                        @click="clickAvatar"
                    />
                    <label
                        style="width: 100px; padding: 40px 0; text-align: center;"
                        @click="clickAvatar"
                        v-else
                        for="avatarb"
                        class="ps_label border border-1 rounded"> {{label.pages.choose}}</label>
                  </b-col>
                  <b-col cols="12" class="text-center pt-4">
                    <input type="file" ref="avatar" id="avatar" class="fs10 mt-1" hidden v-on:change="handleFileUpload()"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="!dropZoneAction" class="my-3">
              <b-col sm="12">
                <drop-zone-custom
                    mode="image"
                    :isRequired="true"
                    :add="dropZoneAction"
                    :edit="!dropZoneAction"
                    :editSrc="form.imageAddress"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addUser"
            >
            {{label.buttons.submitInfo}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
        dir="rtl"
        v-model="editModal"
        header-bg-variant="ps-warning"
        centered
        size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.editUser}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="6">
            <b-row class="mb-3 mt-1">
              <b-col sm="3">
                <label for="firstName" class="ps_label">
                  {{label.form.firstName}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="firstName" size="sm" v-model="form.firstName"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="mb-3 mt-1">
              <b-col sm="3">
                <label for="lastName" class="ps_label">
                  {{label.form.lastName}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="lastName" size="sm" v-model="form.lastName"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="mobile" class="ps_label">
                  {{label.form.phoneNumber}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="mobile" size="sm" v-model="form.mobile" type="number"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="userRole" class="ps_label">
                  {{label.form.userRole}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <treeselect
                    id="userRole"
                    :options="roles"
                    :placeholder="label.pages.searchTitle"
                    v-model="form.role"
                    :normalizer="normalizer"
                    multiple
                ></treeselect>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col sm="3">
                <label for="usernameUser" class="ps_label">
                  {{label.form.username}}
                  <span class="ps_label_star">*</span>
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="usernameUser" name="userUsername" size="sm" autocomplete="off" dir="ltr" v-model="form.username" type="text"/>
              </b-col>
            </b-row>
            <b-row class="mt-4 pt-3">
              <b-col sm="3">
                <label for="nationalCode" class="ps_label">
                  {{label.form.nationalCode}}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="nationalCode" size="sm" v-model="form.nationalCode" type="number"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col cols="3" class="text-center pt-4">
                <label for="image" class="ps_label">
                  {{label.form.avatar}}
                </label>
              </b-col>
              <b-col sm="auto">
                <b-row class="justify-content-center align-self-center">
                  <b-col cols="12" class="profile-avatar align-self-center">
                    <img
                        v-if="form.image"
                        id="avatarb"
                        :src="form.image"
                        style="width: 100px; height: 100px;"
                        alt="user avatar"
                        @click="clickAvatar"
                    />
                    <label
                        style="width: 100px; padding: 40px 0; text-align: center;"
                        @click="clickAvatar"
                        v-else
                        for="avatarb"
                        class="ps_label border border-1 rounded">{{label.pages.choose}}</label>
                  </b-col>
                  <b-col cols="12" class="text-center pt-4">
                    <input type="file" ref="avatar" id="avatar" class="fs10 mt-1" hidden v-on:change="handleFileUpload()"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editUser"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteUserConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteUser"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Ban User Modal -->
    <b-modal
        dir="rtl"
        v-model="banModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center mb-0 lh1">
            {{ label.captions.banUserConfirm}}
            <br/>
            <strong>« {{ banTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="banModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="banUser"
            >
            {{label.buttons.sureBlock}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";

export default {
  name: 'AdminUsersList',
  mixins: [dataGridMixin],
  components: {
    Treeselect,
    dropZoneCustom
  },
  data() {
    return {
      label,
      refreshImage: true,
      dropZoneAction: true,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle fs10'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'firstName',
          caption: 'نام',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'lastName',
          caption: 'نام خانوادگی',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: 'تصویر',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'mobileNumber',
          caption: 'شماره همراه',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'nationalCode',
          caption: 'کد ملی',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'ban',
          caption: 'مسدود کردن',
          allowSorting: false,
          allowFiltering: false,
          width: '80',
          cssClass: 'text-center align-middle'
        },
      ],
      addModal: false,
      form: {
        imageName: '',
        imageAddress: null,
        firstName: null,
        lastName: null,
        fatherName: null,
        role: [],
        nationalCode: null,
        username: null,
        password: null,
        confirmPassword: null,
        image: null,
        address: null,
        mobile: null,
        isActive: true,
      },

      editModal: false,
      editId: null,

      delModal: false,
      delId: null,
      delTitle: '',

      banModal: false,
      banId: null,
      banTitle: null
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      items: 'baseX/personnels',
      loadingBtn: 'loadingBtn',
      roles: 'baseX/roles',
      imageUrl: 'imageUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.banModal = false;
        this.reloadData();
        this.reloadFields();
      }
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.title,
      }
    },
    clickAvatar() {
      this.$refs.avatar.click();
    },
    handleFileUpload() {
      this.avatar = this.$refs.avatar.files[0];
      this.form.image = URL.createObjectURL(this.avatar)
    },
    add() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.$store.commit("setUrlsEmpty");
      this.addModal = true;
      this.form.image = null
    },
    addUser() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.mobile && this.form.mobile != ''
        && this.form.username && this.form.username != ''
        && this.form.password && this.form.password != ''
        && this.form.role && this.form.role != '') {
        if (this.form.password === this.form.confirmPassword){
            let formData = new FormData();
            if (this.form.firstName) {
              formData.append('FirstName', this.form.firstName);
            }
            if (this.form.lastName) {
              formData.append('LastName', this.form.lastName);
            }
            if (this.form.nationalCode) {
              formData.append('NationalCode', this.form.nationalCode);
            }
            if (this.avatar) {
              formData.append('Image', this.avatar);
            }
            if (this.form.role) {
              for (let i = 0; this.form.role.length > i; i) {
                formData.append('Roles', this.form.role[i]);
                i++;
              }
            }
            formData.append('MobileNumber', this.form.mobile);
            formData.append('Username', this.form.username);
            formData.append('Password', this.form.password);
            formData.append('IsActive', true);
            this.$store.dispatch('baseX/addPersonnel', formData);
            this.dropZoneAction = true
        } else {
          this.$store.commit('setError', alert.error.rePassNotMatch)
        }
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    edit(item) {
      this.editId = item.data.id;
      this.form = {
        firstName: item.data.firstName,
        lastName: item.data.lastName,
        mobile: item.data.mobileNumber,
        role: item.data.roleIds,
        nationalCode: item.data.nationalCode,
        username: item.data.username,
        isActive: item.data.isActive,
        imageName: item.data.imageName,
        imageAddress: item.data.imageAddress,
        image: item.data.imageAddress,
      };
      this.editModal = true;
    },
    editUser() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.mobile && this.form.mobile != ''
        && this.form.username && this.form.username != ''
        && this.form.role && this.form.role != ''){
        let formData = new FormData();
        if (this.form.firstName) {
          formData.append('FirstName', this.form.firstName);
        }
        if (this.form.lastName) {
          formData.append('LastName', this.form.lastName);
        }
        if (this.form.nationalCode) {
          formData.append('NationalCode', this.form.nationalCode);
        }
        if (this.avatar) {
          formData.append('Image', this.avatar);
        }
        if (this.form.mobile) {
          formData.append('MobileNumber', this.form.mobile);
        }
        if (this.form.username) {
          formData.append('Username', this.form.username);
        }
        if (this.form.role) {
          for (let i = 0; this.form.role.length > i; i) {
            formData.append('Roles', this.form.role[i]);
            i++;
          }
        }
        const values = {
          id: this.editId,
          value: formData
        };
        this.$store.dispatch('baseX/editPersonnel', values);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.firstName + ' ' + item.data.lastName;
      this.delModal = true;
    },
    deleteUser() {
      this.$store.dispatch('baseX/deletePersonnel', this.delId);
    },
    ban(item) {
      this.banId = item.data.id;
      this.banTitle = item.data.firstName + ' ' + item.data.lastName;
      this.banModal = true;
    },
    banUser() {
      this.$store.dispatch('baseX/banPersonnel', this.banId);
    },
    reloadFields() {
      this.form = {
        firstName: null,
        lastName: null,
        fatherName: null,
        role: [],
        nationalCode: null,
        username: null,
        password: null,
        confirmPassword: null,
        image: null,
        address: null,
        mobile: null,
        isActive: true,
      };
    },
    reloadData() {
      this.$store.dispatch('baseX/getRoles');
      this.$store.dispatch('baseX/getPersonnels');
    },
  },
  mounted() {
    this.reloadData();
  },
}
</script>
